import { FaTimes } from "react-icons/fa";
import Wrapper from "../assets/wrappers/SmallSidebar";
import Logo from "./Logo";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../features/user/userSlice";
import NavLinks from "./NavLinks";
import { motion } from "framer-motion";

function SmallSidebar() {
  const { isSidebarOpen } = useSelector((store) => store.user);
  const dispatch = useDispatch();

  const toggle = () => {
    dispatch(toggleSidebar());
  };

  return (
    <Wrapper>
      <div
        className={isSidebarOpen ? "sidebar-container show-sidebar" : "sidebar-container"}
      >
        <motion.div
          className="content"
          initial={{ x: "-100vw" }}
          animate={{ x: isSidebarOpen ? 0 : "-100vw" }}
          transition={{ type: "spring", stiffness: 80, damping: 15 }}
        >
          <button type="button" className="close-btn" onClick={toggle}>
            <FaTimes />
          </button>
          <header>
            <Logo />
          </header>
          <NavLinks toggleSidebar={toggle} />
        </motion.div>
      </div>
    </Wrapper>
  );
}

export default SmallSidebar;
